// Auto-generated from ICSI2026_Program_Beijing.xlsx
const morningAgenda = [
  {
    "time": "08:00–08:30",
    "duration": "30 min",
    "session": "Tutorial",
    "speaker": ""
  },
  {
    "time": "08:30–08:40",
    "duration": "10 min",
    "session": "Opening Ceremony",
    "speaker": ""
  },
  {
    "time": "08:40–09:40",
    "duration": "60 min",
    "session": "Plenary Speech I",
    "speaker": "Prof. Muhammad Khurram Khan"
  },
  {
    "time": "09:40–10:00",
    "duration": "20 min",
    "session": "Group Photo + Tea Break",
    "speaker": ""
  },
  {
    "time": "10:00–11:00",
    "duration": "60 min",
    "session": "Plenary Speech II",
    "speaker": "Dr. Subhabrata Banerjee"
  },
  {
    "time": "11:00–11:30",
    "duration": "30 min",
    "session": "Invited Speech I",
    "speaker": "JIACHENG LI"
  },
  {
    "time": "11:30–12:00",
    "duration": "30 min",
    "session": "Invited Speech II",
    "speaker": "QiQi Duan"
  },
  {
    "time": "12:00–12:10",
    "duration": "10 min",
    "session": "Awards Ceremony",
    "speaker": ""
  },
  {
    "time": "12:10–14:00",
    "duration": "—",
    "session": "Lunch",
    "speaker": ""
  }
];

export default morningAgenda;
